<ng-template [ngIf]='!!message && code !== "success" && code !== "SU-001"'>
    <div class="alert alert-danger alert-dismissible fade show" role="alert">
      <ng-template [ngIf]='code !== "unverified"'>
          <strong>Error</strong> {{message}}
      </ng-template>
      <ng-template [ngIf]='code === "unverified"'>
        <strong>Error</strong> Your email needs to be verified before access to resources is granted. 
        <br/><br/> You will see this message if you have just signed up or we are periodically asking you to re-verify your email. 
        <br/><br/> If you believe you should have access, please check your emails as you will shortly receive a verification email.
      </ng-template>
    </div>
</ng-template>

<ng-template [ngIf]='!!message && code === "success"'>
  <div class="alert alert-primary alert-dismissible fade show" role="alert">
      <strong>Success</strong> {{message}}
    </div>
</ng-template>

<ng-template [ngIf]='!!message && code === "SU-001"'>
  <div class="alert alert-danger alert-dismissible fade show" role="alert">
      <strong>Error</strong> We were not able to create your account. Please contact your Quantexa account manager with the following details:
      <p>--------------------
      <br/>Error: SU-001
      <br/>Email: {{message}}
      <br/>Timestamp: {{currentDateTime}}</p>
    </div>
</ng-template>